const KEY = 'cvdl_device_id';

export function getDeviceId() {
  let id = localStorage.getItem(KEY);
  if (!id) {
    id = `tablet-${crypto.randomUUID().slice(0, 8)}`;
    localStorage.setItem(KEY, id);
  }
  return id;
}

export function setDeviceId(nombre) {   // 'tablet-01', desde el armado con PIN
  localStorage.setItem(KEY, nombre);
  return nombre;
}

function nuevoId() {
  const rnd = crypto.randomUUID
    ? crypto.randomUUID().slice(0, 8)
    : Math.random().toString(36).slice(2, 10);
  return `tablet-${rnd}`;
}